export const getTokenFromUrl = () => {
  const href = window.location.href;
  const lastSegment = href.substring(href.lastIndexOf('/') + 1);
  const token = lastSegment.indexOf('token');
  if (token === -1) {
    return null;
  }
  const lastSegmentTokenWithState = lastSegment.substring(token + 6);
  const lastSegmentToken = lastSegmentTokenWithState.indexOf('state');
  if (lastSegmentToken === -1) {
    return null;
  }
  const tokenWithOutState = lastSegmentTokenWithState.substring(
    0,
    lastSegmentToken - 1
  );
  if (tokenWithOutState) {
    return tokenWithOutState;
  }
  return '';
};
